import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const CustomModal = ({open, onClose}) => {
  return (
    <Dialog
      open={open}
      onClose={() => {
      }}
      BackdropClick={false}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>
        <span className="redLabel_Dark_Cr_15">
          Session expirée
        </span>
      </DialogTitle>
      <DialogContent>
        <center>
          <span className="greyLabel_Dark_Cr_13">
            Votre Session a été expirée.
            <br/>
            Merci de déconnecter et reconnecter de nouveau.
          </span>
          <br/>
        </center>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomModal;
